import { render, staticRenderFns } from "./KnowledgeUnitCopyView.vue?vue&type=template&id=c787b246&"
import script from "./KnowledgeUnitCopyView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitCopyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports